/////////////// LIB. ///////////////
////////////////////////////////////

// ...

////////////// UTIL. ///////////////
////////////////////////////////////

function openCloseSlideOverlay(slide, config = {}) {
  const { forceAction = null } = config;
  const descrOverlay = slide.querySelector("[data-ref='descrOverlay']");
  const btn_openDescr = slide.querySelector("[data-ref='btn_openDescr']");
  if (!btn_openDescr || !descrOverlay) return;

  const isOpen = descrOverlay.dataset.open === "true";
  let newState;

  if (forceAction === "open") newState = "true";
  else if (forceAction === "close") newState = "false";
  else newState = isOpen ? "false" : "true";

  descrOverlay.dataset.open = newState;
  btn_openDescr.dataset.active = newState;
}

////////// EVENT HANDLERS //////////
////////////////////////////////////

// ...

////////////// ASSETS //////////////
////////////////////////////////////

const msgs = {
  start: ["init. flickity"],
  end: ["init. flickity", "init. success"],
};

//////// INIT. METHOD DEF. /////////
////////////////////////////////////

export default function init_flkty() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { wrpr_slides, slides, btn_prev, btn_next, paginationDots } = this.ref;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  ////////// Flickity init. //////////
  ////////////////////////////////////

  let blockSlideAction = false;

  const inst_flkty = new Flickity(wrpr_slides, {
    cellSelector: "[g-ref='slides']",
    wrapAround: false,
    cellAlign: "left",
    contain: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.01,
    friction: 0.2,
    draggable: true,
    imagesLoaded: true,
    on: {
      /////////// Slider ready event hdl. ////////////
      ////////////////////////////////////////////////

      // ready: () => {
      //   if (this.options.logs) console.log("Slider ready.");
      // },

      /////////// Slide change event hdl. ////////////
      ////////////////////////////////////////////////

      change: (i_activeSlide) => {
        // Pagination updt. //
        if (paginationDots) paginationDots.forEach((dot, i) => (dot.dataset.active = i === i_activeSlide ? "true" : "false"));

        // Close any open overlays on all slides
        slides.forEach((s) => openCloseSlideOverlay(s, { forceAction: "close" }));
      },
    },
  });

  ///// Mouse interaction init. //////
  ////////////////////////////////////

  wrpr_slides.addEventListener("mousemove", (e) => {
    const is_onLeftHalf = e.clientX < window.innerWidth / 2;
    wrpr_slides.classList.toggle("tw:cursor-slide-left", is_onLeftHalf);
    wrpr_slides.classList.toggle("tw:cursor-slide-right", !is_onLeftHalf);
  });

  // wrpr_slides.addEventListener("click", (e) => {
  //   if (!e.target.closest("[data-ref='btn_show_ext']")) {
  //     // Check if click was not on btn. that opens content box
  //     // Close any open extended-content-box
  //     this.setState({ openExtendedContentBox: "none" });

  //     // Navigate slides based on click position
  //     const clickedOnLeft = e.clientX < window.innerWidth / 2;
  //     if (clickedOnLeft) inst_flickity.previous();
  //     else if (!blockSlideAction) inst_flickity.next();
  //   }
  // });

  ///// Slide interaction init. //////
  ////////////////////////////////////

  slides.forEach((slide) => {
    const descrOverlay = slide.querySelector("[data-ref='descrOverlay']");
    const btn_openDescr = slide.querySelector("[data-ref='btn_openDescr']");
    if (!btn_openDescr || !descrOverlay) return;
    btn_openDescr.addEventListener("click", () => openCloseSlideOverlay(slide));
  });

  /////////// Ctrl. init. ////////////
  ////////////////////////////////////

  if (btn_prev) btn_prev.addEventListener("click", () => inst_flkty.previous());
  if (btn_next) btn_next.addEventListener("click", () => inst_flkty.next());

  ///////////// Conclude /////////////
  ////////////////////////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
